import { render } from "./DewarSection.vue?vue&type=template&id=7136b8a4&scoped=true"
import script from "./DewarSection.vue?vue&type=script&lang=js"
export * from "./DewarSection.vue?vue&type=script&lang=js"

import "./DewarSection.vue?vue&type=style&index=0&id=7136b8a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7136b8a4"]])

export default __exports__